
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgChartsModule } from 'ng2-charts';
import { FileUploadModule } from 'ng2-file-upload';
import { MatInputModule } from '@angular/material/input';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatStepperModule } from '@angular/material/stepper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatChipsModule } from '@angular/material/chips';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatNativeDateModule } from '@angular/material/core';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { NgSelectModule } from '@ng-select/ng-select';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgxSpinnerModule } from 'ngx-spinner';
import { HttpClientModule } from '@angular/common/http';
import { NgApexchartsModule } from 'ng-apexcharts';
import { ToastrModule } from 'ngx-toastr';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../shared/shared.module';

import { SdpLayoutsRoutingModule } from './sdp-layouts-routing.module';
import { SdpLayoutsComponent } from './sdp-layouts.component';
import { SdpHeaderComponent } from './sdp-header/sdp-header.component';
import { SdpFooterComponent } from './sdp-footer/sdp-footer.component';
import { SdpSidebarComponent } from './sdp-sidebar/sdp-sidebar.component';
import { DashboardComponent as OperatorDashboard } from '../operator/dashboard/dashboard.component';
import { DashboardComponent as AdminDashboard } from '../admin/dashboard/dashboard.component'
import { DashboardComponent as OfficerDashboard } from '../officer/dashboard/dashboard.component';
import { DashboardComponent as MCDashboard } from '../municipal-commissioner/dashboard/dashboard.component';
import { NewComplaintComponent } from '../operator/new-complaint/new-complaint.component';
import { ComplaintComponent } from '../operator/complaint/complaint.component';
import { PendingComplaintsComponent } from '../officer/pending-complaints/pending-complaints.component';
import { ResolvedComplaintsComponent } from '../officer/resolved-complaints/resolved-complaints.component';
import { SearchComplaintsComponent } from '../officer/search-complaints/search-complaints.component';
import { UserManagementComponent } from '../admin/user-management/user-management.component';
import { DepManagementComponent } from '../admin/dep-management/dep-management.component';
import { EscalationMatrixComponent } from '../admin/escalation-matrix/escalation-matrix.component';
import { ZoneWordMappingComponent } from '../admin/zone-word-mapping/zone-word-mapping.component';
import { UpdateComplaintsComponent } from '../officer/update-complaints/update-complaints.component';
import {HierarchyComponent} from '../admin/hierarchy/hierarchy.component'
import { UpdatesdetailsmodalComponent } from '../officer/updatesdetailsmodal/updatesdetailsmodal.component';
import { SuccessModalWithCheckComponent } from '../operator/success-modal-with-check/success-modal-with-check.component';
import { SuccessModalWithoutCheckComponent } from '../operator/success-modal-without-check/success-modal-without-check.component';
import {PreviewComponent} from '../components/preview/preview.component'
import {HomeComponent} from '../home/home.component'
import { RoleComponent } from '../admin/role/role.component';
import { UserComponent } from '../admin/user/user.component';
import { UserProfileComponent } from './user-profile/user-profile.component';
import { ClosedComplaintsComponent } from '../../sdp/officer/closed-complaints/closed-complaints.component';
import { EscalatedComplaintsComponent } from '../../sdp/officer/escalated-complaints/escalated-complaints.component';
import { TotalGrevianceComponent } from '../../sdp/municipal-commissioner/total-greviance/total-greviance.component';
import { PendingsMcComponent } from '../../sdp/municipal-commissioner/pendings-mc/pendings-mc.component';
import { TodayGrevianceComponent } from '../../sdp/municipal-commissioner/today-greviance/today-greviance.component';
import {AccountProfileComponent} from '../../portal/account-profile/account-profile.component'

@NgModule({
  declarations: [
    HomeComponent,
    SdpLayoutsComponent,
    SdpHeaderComponent,
    SdpFooterComponent,
    SdpSidebarComponent,
    OperatorDashboard,
    AdminDashboard,
    OfficerDashboard,
    MCDashboard,
    NewComplaintComponent,
    RoleComponent,
    UserComponent,
    ComplaintComponent,
    PendingComplaintsComponent,
    ResolvedComplaintsComponent,
    SearchComplaintsComponent,
    UserManagementComponent,
    DepManagementComponent,
    EscalationMatrixComponent,
    ZoneWordMappingComponent,
    UpdatesdetailsmodalComponent,
    SuccessModalWithCheckComponent,
    SuccessModalWithoutCheckComponent,
    UpdateComplaintsComponent,
    PreviewComponent,
    UserProfileComponent,
    AccountProfileComponent,
    HierarchyComponent,
    ClosedComplaintsComponent,
    EscalatedComplaintsComponent,
    TotalGrevianceComponent,
        PendingsMcComponent,
            TodayGrevianceComponent


  ],
  exports: [
    SdpLayoutsComponent,
    SdpHeaderComponent,
    SdpFooterComponent,
    SdpSidebarComponent,
  ],
  imports: [
    CommonModule,
    SdpLayoutsRoutingModule,
    RouterModule,
    SharedModule,
    MatCardModule,
    MatIconModule,
    MatSelectModule,
    NgSelectModule,
    NgChartsModule,
    FileUploadModule,
    MatInputModule,
    MatMenuModule,
    MatIconModule,
    MatSlideToggleModule,
    FormsModule,
    MatStepperModule,
    MatCheckboxModule,
    MatExpansionModule,
    NgxSpinnerModule,
    HttpClientModule,
    MatSnackBarModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatCardModule,
    MatChipsModule,
    MatDividerModule,
    MatGridListModule,
    MatDialogModule,
    MatButtonModule,
    MatSortModule,
    MatTableModule,
    NgApexchartsModule,
    ReactiveFormsModule,
    MatTabsModule,
    ToastrModule.forRoot(),
  ],
  schemas: [NO_ERRORS_SCHEMA]

})
export class SdpLayoutsModule { }
